module.exports = __webpack_public_path__ + "static/media/slide4.23026ff0.png";